/**
 * TimeTrack - Entry Point
 */

import { render } from 'preact';
import { App } from './app';

// Import global styles
import './styles/global.css';

// Initialize stores (side-effect imports)
import './stores/theme.store'; // Applies saved theme on load

// =============================================================================
// Bootstrap
// =============================================================================

function bootstrap(): void {
  console.info('[App] Starting TimeTrack...');

  const root = document.getElementById('root');

  if (root) {
    render(<App />, root);
    console.info('[App] App mounted');
  } else {
    console.error('[App] Root element not found');
  }
}

// Start the app
bootstrap();
